import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Stack from "@mui/material/Stack";
import { toast } from "react-toastify";
import axios from "axios";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  validateCaptcha,
} from "react-simple-captcha";
import Cookies from "js-cookie";
import { useGetprofileapiQuery } from "../Store/Middleware/api/getProfileAPI";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 5,
  color: "black",
  outline: "none",
};

export default function ConfirmModal({
  isOpen,
  setIsOpen,
  responseData,
  id,
  getAllData,
  apiJodApply,
}) {
  const handleClose = () =>
    setIsOpen((prev) => ({
      ...prev,
      isConfirm: !isOpen.isConfirm,
    }));

  const [value, setValue] = React.useState("yes");
  const [newResume, setResume] = React.useState();
  const token = Cookies.get("authToken");
  const { data } = useGetprofileapiQuery();

  React.useEffect(() => {
    if (true) {
      setTimeout(() => loadCaptchaEnginge(6), 10);
    }
  }, []);

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleUploadNewResume = (event) => {
    const file = event.target.files[0];

    if (!file) {
      toast.error("No file selected.");
      return;
    }

    const fileSizeInMB = file.size / (1024 * 1024);
    const fileExtension = file.name.split(".").pop()?.toLowerCase();

    if (fileSizeInMB > 6) {
      toast.error("File size exceeds the 6 MB limit.");
      return;
    } else if (!["pdf", "docx", "txt"].includes(fileExtension)) {
      toast.error(
        "Invalid file format. Only PDF, DOCX, or TXT files are allowed.",
      );
      return;
    } else {
      setResume(event.target.files[0]);
    }
  };

  const handleApply = () => {
    let user_captcha_value =
      document.getElementById("user_captcha_input").value;
    if (validateCaptcha(user_captcha_value) === true) {
      if (value === "no") {
        const candidateId = localStorage.getItem("candidate_id");
        const formData = new FormData();
        formData.append("candidate_id", candidateId);
        formData.append("resume", newResume);

        axios
          .post(
            `${process.env.REACT_APP_API_URL}/user-resume-upload`,
            formData,
            {
              headers: {
                authorization: token,
              },
            },
          )
          .then((response) => {
            if (response?.status === 401) {
              localStorage.clear();
              Cookies.remove("_secure_ARJ_");
              window.location.href = "/login";
            }
            if (response.status === 200) {
              // toast.success("Resume Uploaded Successfully");
              // return;
            } else {
              toast.error(response.message);
            }
          })
          .catch((err) => {
            toast.error(err);
          });
        apiJodApply({
          token: token,
          job_id: Number(id),
          cover_letter: "",
          additional_info: "",
          email: localStorage.getItem("userID"),
          title: responseData?.title,
        })
          .then((response) => {
            if (response?.data?.success) {
              toast.success("Job Applied Successfully");
              getAllData();
            } else if (response?.status === 401) {
              localStorage.clear();
              Cookies.remove("_secure_ARJ_");
              window.location.href = "/login";
            }
          })
          .catch((error) => {
            console.error("Error", error);
            toast.error("Error applying for the job");
          });
      } else if (value === "yes") {
        apiJodApply({
          token: token,
          job_id: Number(id),
          cover_letter: "",
          additional_info: "",
          email: localStorage.getItem("userID"),
          title: responseData?.title,
        })
          .then((response) => {
            if (response?.data?.success) {
              toast.success("Job Applied Successfully");
              getAllData();
            } else if (response?.status === 401) {
              localStorage.clear();
              Cookies.remove("_secure_ARJ_");
              window.location.href = "/login";
            }
          })
          .catch((error) => {
            console.error("Error applying for the job:", error);
            toast.error("Error applying for the job");
          });
      }
      handleClose();
      localStorage.removeItem("loginUrl");
    } else {
      alert("Captcha Does Not Match");
    }
  };

  return (
    <div>
      <Modal
        open={isOpen.isConfirm}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Confirm Your Application
            </Typography>
            <CloseIcon sx={{ cursor: "pointer" }} onClick={handleClose} />
          </div>
          <FormControl style={{ paddingTop: "1rem" }}>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={value}
              onChange={handleChange}
            >
              <FormControlLabel
                value="yes"
                control={<Radio />}
                label="Are you sure you want to continue with the existing resume/cv?"
              />
              {value === "yes" && (
                <div
                  style={{
                    color: "#1976d2",
                    fontSize: "16px",
                    paddingTop: "0.75rem",
                    paddingBottom: "0.2rem",
                    textAlign: "center",
                  }}
                >
                  {data?.message?.details?.resume}
                </div>
              )}
              <FormControlLabel
                value={"no"}
                control={<Radio />}
                label="I want to upload a new resume/cv."
              />
              {value === "no" && (
                <div
                  style={{
                    paddingTop: "0.75rem",
                    display: "flex",
                    gap: "0.5rem",
                    alignItems: "center",
                  }}
                >
                  <Button
                    component="label"
                    role={undefined}
                    variant="contained"
                    tabIndex={-1}
                    startIcon={<CloudUploadIcon />}
                    color="secondary"
                  >
                    Upload Resume/cv
                    <VisuallyHiddenInput
                      type="file"
                      onChange={(event) => handleUploadNewResume(event)}
                      multiple
                    />
                  </Button>
                  <div
                    style={{
                      color: "#1976d2",
                      fontSize: "16px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "200px",
                    }}
                    title={newResume?.name}
                  >
                    {newResume?.name}
                  </div>
                </div>
              )}
            </RadioGroup>
            <div style={{ display: "flex", paddingTop: "20px" }}>
              <LoadCanvasTemplate />
              <input
                type="text"
                id="user_captcha_input"
                placeholder="Enter Captcha Code"
                style={{
                  width: "80%",
                  padding: "10px",
                  margin: "10px 0",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  fontSize: "16px",
                  outline: "none",
                  transition: "border 0.3s ease",
                }}
                onFocus={(e) => (e.target.style.border = "1px solid #333")}
                onBlur={(e) => (e.target.style.border = "1px solid #ccc")}
              />
            </div>
          </FormControl>
          <Stack
            spacing={2}
            direction="row"
            sx={{ marginTop: "2rem", display: "flex", justifyContent: "end" }}
          >
            <Button variant="contained" color="error" onClick={handleClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleApply}
              disabled={(() => {
                if (value === "yes") {
                  return data?.message?.details?.resume === "No Resume";
                }
                if (value === "no") {
                  return newResume?.name ? false : true;
                }
              })()}
            >
              Apply
            </Button>
          </Stack>
        </Box>
      </Modal>
    </div>
  );
}
